export const EditIcon = ({ ...props }) => {
  return (
    <svg height="18" viewBox="0 0 18 18" width="18" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="m2.85 10.907-.672 1.407-2.145 4.946a.535.535 0 0 0 0 .368.917.917 0 0 0 .155.184.917.917 0 0 0 .184.155.54.54 0 0 0 .188.033.48.48 0 0 0 .18-.033l4.946-2.145 1.407-.672 8.53-8.53-4.244-4.243zm2.007 3.093-1.515.657.658-1.514.508-1.064 1.415 1.413zm11.85-8.463-4.244-4.244.707-.707a2 2 0 0 1 2.83 0l1.414 1.414a2 2 0 0 1 0 2.83z"
        fill="#494c4e"
        {...props}
      />
    </svg>
  );
};
